/**
 * Freemium model constants for smart summary feature
 *
 * ⚠️ SECURITY NOTE: Client-side enforcement only
 * This quota is enforced in localStorage and can be bypassed by users
 * who clear their browser storage or manipulate localStorage directly.
 * Backend validation should be added in future for production security.
 * Current implementation prioritizes UX and offline capability over
 * strict enforcement.
 */

/**
 * Number of free smart summaries available to non-Pro users
 * before requiring upgrade
 */
export const FREE_SMART_SUMMARY_LIMIT = 3;

/**
 * Cooldown period in minutes between smart summary generation requests
 * Applies to both Pro and Free users to prevent spam
 */
export const SMART_SUMMARY_COOLDOWN_MINUTES = 10;

/**
 * Duration of trial period in days for new subscriptions
 * Used for AppsFlyer trial lifecycle tracking and fee/backend registration
 */
export const TRIAL_DURATION_DAYS = 7;

/**
 * Number of free collections visible to non-Pro users before requiring upgrade.
 * - CollectionsList: applied per section/row (first N in each row are free)
 * - IdeasPage: applied to the single featured row as a whole (first N cards are free)
 */
export const FREE_COLLECTIONS_LIMIT = 2;

/**
 * Number of free trades visible to non-Pro users
 * before requiring upgrade (used in LatestTradesCard and TradesHistoryPage)
 */
export const FREE_TRADES_LIMIT = 3;

/**
 * Daily limit for premium model requests
 * Premium models (Claude Opus, Gemini Pro, GPT 5.2) require subscription
 *
 * ⚠️ SECURITY NOTE: Client-side enforcement only (same as smart summaries)
 */
export const DAILY_PREMIUM_MODEL_LIMIT = 20;

/**
 * Chat model configuration for user selection
 */
export interface ChatModel {
  id: string;
  displayName: string;
  requiresSubscription: boolean;
}

/**
 * Available chat models for user selection
 * Models with requiresSubscription: true are locked for non-subscribers
 */
export const CHAT_MODELS: ChatModel[] = [
  { id: 'default', displayName: 'Default', requiresSubscription: false },
  { id: 'claude', displayName: 'Claude Opus 4.6', requiresSubscription: true },
  { id: 'gemini', displayName: 'Gemini 3.1 Pro', requiresSubscription: true },
  { id: 'gpt', displayName: 'GPT 5.2', requiresSubscription: true },
];
